/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './loanjumbosection.css';
import parse from 'html-react-parser';

function LoanJumboSection({ data }) {
  // If no data is provided, don't render the component
  if (!data) return null;
  
  // Destructure data to get all props
  const { sections, calculatorButton } = data;
  
  // If no sections or empty sections array, don't render
  if (!sections || sections.length === 0) return null;
  
  return (
    <section className="loan-jumbo-section">
      <Container>
        {sections && sections.length > 0 && (
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="jumbo-sections-container">
                {sections.map((section, index) => {
                  const customHeadingStyle = section.headingColor ? 
                    { 
                      color: section.headingColor,
                      textDecorationColor: section.headingColor 
                    } : {};
                  
                  return (
                    <div key={index} className="jumbo-section-item jumbo-title-section">
                      {section.heading && (
                        <h3 className="jumbo-title" style={customHeadingStyle}>
                          {parse(section.heading)}
                        </h3>
                      )}
                      
                      {section.isKeyConsiderations && section.keyConsiderationsItems ? (
                        <div className="key-considerations-container">
                          <ul className="key-considerations-list">
                            {section.keyConsiderationsItems.map((item, idx) => (
                              <li key={idx} className="key-consideration-item">
                                <span className="key-consideration-title">{parse(item.title)}</span>
                                <div className="key-consideration-content">
                                  {parse(item.content)}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        section.content && (
                          <div className="jumbo-section-content">{parse(section.content)}</div>
                        )
                      )}
                    </div>
                  );
                })}
                
                {/* Calculator Button */}
                {calculatorButton && (
                  <div className="jumbo-calculator-button-container">
                    <a 
                      href={calculatorButton.url} 
                      target={calculatorButton.targetType === 'external' ? '_blank' : '_self'} 
                      rel={calculatorButton.targetType === 'external' ? 'noopener noreferrer' : ''}
                      className="jumbo-calculator-button"
                    >
                      {parse(calculatorButton.text)}
                      <div className="jumbo-calculator-icon-div">
                        {calculatorButton.iconUrl && (
                          <img 
                            src={calculatorButton.iconUrl} 
                            alt="Calculator" 
                            className="jumbo-calculator-icon" 
                          />
                        )}
                      </div>
                    </a>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
}

export default LoanJumboSection;